import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function BIR2316({isHideSideMenu}) {
    const currentYear = new Date().getFullYear();
    const [loading, setLoading] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [dateFrom, setDateFrom] = useState(`${currentYear}-01-01`);
    const [dateTo, setDateTo] = useState(`${currentYear}-12-27`);

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [errorState, setErrorState] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const formatName = (name) => {
        if(name){
            const nameParts = name.split(", ");
            const formattedName = nameParts.map(part => {
                return part.split('-').map(subPart => 
                    subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase()
                ).join('-');
            }).join(", ");

            return formattedName.replace(/\b\w/g, (match) => match.toUpperCase());
        }
        return "";
    };

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const generate = () =>{
        if(!employeePersonalInformationId || !dateFrom || !dateTo){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont12Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 12, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        try {
            // Load the existing PDF from the public folder
            const pdfUrl = `${window.location.origin}/docs/BIR_2316.pdf`;
    
            // Fetch the existing PDF as a binary array
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
    
            // Load the PDF with pdf-lib
            const pdfDoc = await PDFDocument.load(pdfBytes);
    
            // Get the first page of the PDF
            const page = pdfDoc.getPages()[0];
            const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

            //CONTENT
            //For period
            const [periodDateFrom_year, periodDateFrom_month, periodDateFrom_day] = dateFrom.split("T")[0].split("-");
            const periodDateFrom_yearText = periodDateFrom_year.split('').map(data => data);
            const periodDateFrom_monthText = periodDateFrom_month.split('').map(data => data);
            const periodDateFrom_dayText = periodDateFrom_day.split('').map(data => data);

            periodDateFrom_monthText.forEach((text, index) => {
                writeFont8Black({page: page, font: font, x: 394 + (index * 15), y: 830, text: `${text}`})
            })
            periodDateFrom_dayText.forEach((text, index) => {
                writeFont8Black({page: page, font: font, x: 430 + (index * 15), y: 830, text: `${text}`})
            })
            periodDateFrom_yearText.forEach((text, index) => {
                // writeFont8Black({page: page, font: font, x: 100 + (index * 13), y: 670, text: `${text}`})
            })

            const [periodDateTo_year, periodDateTo_month, periodDateTo_day] = dateTo.split("T")[0].split("-");
            const periodDateTo_yearText = periodDateTo_year.split('').map(data => data);
            const periodDateTo_monthText = periodDateTo_month.split('').map(data => data);
            const periodDateTo_dayText = periodDateTo_day.split('').map(data => data);

            periodDateTo_monthText.forEach((text, index) => {
                writeFont8Black({page: page, font: font, x: 520 + (index * 15), y: 830, text: `${text}`})
            })
            periodDateTo_dayText.forEach((text, index) => {
                writeFont8Black({page: page, font: font, x: 555 + (index * 15), y: 830, text: `${text}`})
            })
            //year
            periodDateTo_yearText.forEach((text, index) => {
                writeFont8Black({page: page, font: font, x: 130 + (index * 18), y: 830, text: `${text}`})
            })

            //tin
            const tinInitialValue = data.employeeAccountInformation?.tin ?? null;
            if(tinInitialValue){
                const tinNumberOnly = tinInitialValue.replace(/\D/g, "");

                const tinArray = tinNumberOnly.split("");
                const tinText = {
                    firstPart: tinArray.slice(0, 3).map(data => data),
                    secondPart: tinArray.slice(3, 6).map(data => data),
                    thirdPart: tinArray.slice(6, 9).map(data => data),
                    fourthPart: tinArray.slice(9).map(data => data), // The rest
                };

                tinText.firstPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 90 + (index * 13), y: 802, text: `${text}`})
                })
                tinText.secondPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 140 + (index * 13), y: 802, text: `${text}`})
                })
                tinText.thirdPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 190 + (index * 13), y: 802, text: `${text}`})
                })
                tinText.fourthPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 240 + (index * 14), y: 802, text: `${text}`})
                })
            }

            //name 
            writeFont8Black({page: page, font: font, x: 50, y: 777, text: formatName(`${data.lastName}, ${data.firstName} ${data.middleName ?? ""}`)})

            //registered address
            const regAddressValue = `${data.blkLot + " " ?? ""}${data.street + " " ?? ""}${data.barangay + " " ?? ""}${data.city + " " ?? ""}`;
            writeFont8Black({page: page, font: font, x: 50, y: 748, text: regAddressValue})
            //registered address zip code
            const regZipCodeValue = data.postalCode ?? "";
            if(regZipCodeValue){
                const regZipCodeText = regZipCodeValue.split('').map(data => data);
                regZipCodeText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 265 + (index * 12), y: 748, text: `${text}`})
                })
            }

            //local home address
            const localHomeAddressValue = `${data.blkLot + " " ?? ""}${data.street + " " ?? ""}${data.barangay + " " ?? ""}${data.city + " " ?? ""}`;
            writeFont8Black({page: page, font: font, x: 50, y: 722, text: localHomeAddressValue})
            //registered address zip code
            const localZipCodeValue = data.postalCode ?? "";
            if(localZipCodeValue){
                const localZipCodeText = localZipCodeValue.split('').map(data => data);
                localZipCodeText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 265 + (index * 12), y: 722, text: `${text}`})
                })
            }

            //foreign address
            const foreignAddressValue = `${data.blkLot + " " ?? ""}${data.street + " " ?? ""}${data.barangay + " " ?? ""}${data.city + " " ?? ""}`;
            writeFont8Black({page: page, font: font, x: 50, y: 697, text: foreignAddressValue})

            // date of birth
            const dateOfBirthValue = data.dateOfBirth ? data.dateOfBirth : null;
            if(dateOfBirthValue){
                const [dob_year, dob_month, dob_day] = dateOfBirthValue.split("T")[0].split("-");
                const dob_yearText = dob_year.split('').map(data => data);
                const dob_monthText = dob_month.split('').map(data => data);
                const dob_dayText = dob_day.split('').map(data => data);
    
                dob_monthText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 50 + (index * 14), y: 670, text: `${text}`})
                })
                dob_dayText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 76 + (index * 14), y: 670, text: `${text}`})
                })
                dob_yearText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 100 + (index * 13), y: 670, text: `${text}`})
                })
            }

            //contact number
            const contactNumberValue = data.mobileNumber ?? "";
            
            if(contactNumberValue){
                let formattedNumber = contactNumberValue;

                // Convert +63 to 09 if it starts with +63
                if (formattedNumber.startsWith("+63")) {
                    formattedNumber = "09" + formattedNumber.slice(3);
                }

                const contactNumberValueNumberOnly = formattedNumber.replace(/\D/g, "");

                const contactNumberText = contactNumberValueNumberOnly.split('').map(data => data);

                contactNumberText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 170 + (index * 13), y: 670, text: `${text}`})
                })
            }

            //minimum wage per day
            const minimumWagePerDayValue = 500;
            writeFont8Black({page: page, font: font, x: 215, y: 653, text: numberWithCommasAndDecimal(minimumWagePerDayValue)})

            //minimum wage per month
            const minimumWagePerMonthValue = 15000;
            writeFont8Black({page: page, font: font, x: 215, y: 635, text: numberWithCommasAndDecimal(minimumWagePerMonthValue)})

            //MWE 
            const mwe = true;
            if(mwe){
                writeFont12Black({page: page, font: dingbatsFont, x: 52, y: 618, text: "✓"})
            }

            //company tin
            const companyTinInitialValue = data.employeeInformation?.companyTin ?? null;
            if(companyTinInitialValue){
                const companyTinNumberOnly = companyTinInitialValue.replace(/\D/g, "");

                const companyTinArray = companyTinNumberOnly.split("");
                const companyTinText = {
                    firstPart: companyTinArray.slice(0, 3).map(data => data),
                    secondPart: companyTinArray.slice(3, 6).map(data => data),
                    thirdPart: companyTinArray.slice(6, 9).map(data => data),
                    fourthPart: companyTinArray.slice(9).map(data => data), // The rest
                };

                companyTinText.firstPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 90 + (index * 13), y: 589, text: `${text}`})
                })
                companyTinText.secondPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 140 + (index * 13), y: 589, text: `${text}`})
                })
                companyTinText.thirdPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 190 + (index * 13), y: 589, text: `${text}`})
                })
                companyTinText.fourthPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 240 + (index * 14), y: 589, text: `${text}`})
                })
            }

            //employer's name
            const employerName = data.employeeInformation?.companyName ?? "";
            writeFont8Black({page: page, font: font, x: 50, y: 563, text: employerName})

            //employer's address
            const employerAddress = data.employeeInformation?.companyAddress ?? "";
            writeFont8Black({page: page, font: font, x: 50, y: 537, text: employerAddress})

            //employer's zip code
            const employerZipCode = data.postalCode ?? "";
            if(employerZipCode){
                const employerZipCodeText = employerZipCode.split('').map(data => data);
                employerZipCodeText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 263 + (index * 12), y: 537, text: `${text}`})
                })
            }

            //type of employer
            const mainEmployer = true;
            const secondaryEmployer = false;
            if(mainEmployer){
                writeFont12Black({page: page, font: dingbatsFont, x: 118, y: 520, text: "✓"})
            }
            if(secondaryEmployer){
                writeFont12Black({page: page, font: dingbatsFont, x: 203, y: 520, text: "✓"})
            }

            //company tin previous
            const companyTinInitialValuePrevious = data.employeeInformation?.companyTin ?? null;
            if(companyTinInitialValuePrevious){
                const companyTinNumberOnlyPrevious = companyTinInitialValuePrevious.replace(/\D/g, "");

                const companyTinArrayPrevious = companyTinNumberOnlyPrevious.split("");
                const companyTinTextPrevious = {
                    firstPart: companyTinArrayPrevious.slice(0, 3).map(data => data),
                    secondPart: companyTinArrayPrevious.slice(3, 6).map(data => data),
                    thirdPart: companyTinArrayPrevious.slice(6, 9).map(data => data),
                    fourthPart: companyTinArrayPrevious.slice(9).map(data => data), // The rest
                };

                companyTinTextPrevious.firstPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 90 + (index * 13), y: 492, text: `${text}`})
                })
                companyTinTextPrevious.secondPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 140 + (index * 13), y: 492, text: `${text}`})
                })
                companyTinTextPrevious.thirdPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 190 + (index * 13), y: 492, text: `${text}`})
                })
                companyTinTextPrevious.fourthPart.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 240 + (index * 14), y: 492, text: `${text}`})
                })
            }

            //employer's name previous
            const employerNamePrevious = data.employeeInformation?.companyName ?? "";
            writeFont8Black({page: page, font: font, x: 50, y: 467, text: employerNamePrevious})

            //employer's address previous
            const employerAddressPrevious = data.employeeInformation?.companyAddress ?? "";
            writeFont8Black({page: page, font: font, x: 50, y: 441, text: employerAddressPrevious})

            //employer's zip code previous
            const employerZipCodePrevious = data.postalCode ?? "";
            if(employerZipCodePrevious){
                const employerZipCodePreviousText = employerZipCodePrevious.split('').map(data => data);
                employerZipCodePreviousText.forEach((text, index) => {
                    writeFont8Black({page: page, font: font, x: 263 + (index * 12), y: 441, text: `${text}`})
                })
            }

            //gross compensation income from present employer
            const grossIncomeFromEmployer = data.grossCompensationIncome ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 412, text: numberWithCommasAndDecimal(grossIncomeFromEmployer)})

            //less total non taxable income from present employer
            const nonTaxableIncomeFromEmployer = data.lessTotalNonTaxableCompensation ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 392, text: numberWithCommasAndDecimal(nonTaxableIncomeFromEmployer)})

            //taxable income from present employer
            const taxableIncomeFromEmployer = data.taxableCompensationFromPresentEmployer ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 372, text: numberWithCommasAndDecimal(taxableIncomeFromEmployer)})

            //taxable income from previous employer
            const taxableIncomeFromEmployerPrevious = data.taxableCompensationFromPreviousEmployer ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 353, text: numberWithCommasAndDecimal(taxableIncomeFromEmployerPrevious)})

            //gross taxable compensation income
            const grossTaxableIncome = data.grossTaxableCompensationIncome ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 335, text: numberWithCommasAndDecimal(grossTaxableIncome)})

            //tax due
            const taxDue = data.taxDue ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 315, text: numberWithCommasAndDecimal(taxDue)})

            //tax withheld present employer
            const taxWithheldEmployer = data.presentEmployer25A ?? 0 ;
            writeFont8Black({page: page, font: font, x: 215, y: 295, text: numberWithCommasAndDecimal(taxWithheldEmployer)})

            //tax withheld previous employer
            const taxWithheldEmployerPrevious = data.presentEmployer25B ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 275, text: numberWithCommasAndDecimal(taxWithheldEmployerPrevious)})

            //total amount of taxes withheld as adjusted
            const totalAmountOfTaxWithheld = data.totalAmountTaxesWithHeld ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 255, text: numberWithCommasAndDecimal(totalAmountOfTaxWithheld)})

            //5% tax credit
            const fivePercentTaxCredit = data.tax5Credit ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 235, text: numberWithCommasAndDecimal(fivePercentTaxCredit)})

            //total taxes withheld 
            const totalTaxWithheld = data.totalTaxesWithheld ?? 0;
            writeFont8Black({page: page, font: font, x: 215, y: 215, text: numberWithCommasAndDecimal(totalTaxWithheld)})

            //basic salary
            const basicSalary = data.isTaxableSalary ? 0 : data.basicSalary;
            writeFont8Black({page: page, font: font, x: 490, y: 783, text: numberWithCommasAndDecimal(basicSalary)})

            //holiday Pay
            const holidayPay = data.holidayPay ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 763, text: numberWithCommasAndDecimal(holidayPay)})

            //overtime pay
            const overtimePay = data.isTaxableSalary ? 0 : data.otPay;
            writeFont8Black({page: page, font: font, x: 490, y: 743, text: numberWithCommasAndDecimal(overtimePay)})

            //night shift differential
            const nightDiff = data.totalNighDiff ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 723, text: numberWithCommasAndDecimal(nightDiff)})

            //hazard pay
            const hazardPay = data.isTaxableSalary ? 0 : data.hazardPay;
            writeFont8Black({page: page, font: font, x: 490, y: 703, text: numberWithCommasAndDecimal(hazardPay)})

            //13th month
            const thirteenthMonth = data.isTaxableSalary ? 0 : data.nonTaxable13thMonth;
            writeFont8Black({page: page, font: font, x: 490, y: 683, text: numberWithCommasAndDecimal(thirteenthMonth)})

            //de minimis benefits
            const deMinimisBenefits = data.deMinimisBenefits ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 665, text: numberWithCommasAndDecimal(deMinimisBenefits)})

            //contributions
            const contribution = data.contributions ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 647, text: numberWithCommasAndDecimal(contribution)})

            //salaries and other forms of compensation
            const otherFormsOfCompensation = data.salariesCompensation ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 627, text: numberWithCommasAndDecimal(otherFormsOfCompensation)})

            // exempt compensation 
            const exemptCompensation = data.totalNonTaxableCompensation ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 607, text: numberWithCommasAndDecimal(exemptCompensation)})

            //taxable basic salary
            const taxableBasicSalary = data.isTaxableSalary ? data.basicSalary : 0;
            writeFont8Black({page: page, font: font, x: 490, y: 570, text: numberWithCommasAndDecimal(taxableBasicSalary)})

            //representation 
            const representation = data.representation ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 550, text: numberWithCommasAndDecimal(representation)})

            //transportation
            const transportation = data.transportation ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 530, text: numberWithCommasAndDecimal(transportation)})

            //cola
            const cola = data.cola ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 512, text: numberWithCommasAndDecimal(cola)})

            //fixed housing allowance 
            const housingAllowance = data.fixedHousingAllowance ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 493, text: numberWithCommasAndDecimal(housingAllowance)})

            //others
            const A44 = ""
            const B44 = ""
            const A44Value = data.nonTaxableOthersA ?? 0;
            const B44Value = data.nonTaxableOthersB ?? 0;
            writeFont8Black({page: page, font: font, x: 350, y: 465, text: A44})
            writeFont8Black({page: page, font: font, x: 350, y: 447, text: B44})
            writeFont8Black({page: page, font: font, x: 490, y: 465, text: numberWithCommasAndDecimal(A44Value)})
            writeFont8Black({page: page, font: font, x: 490, y: 447, text: numberWithCommasAndDecimal(B44Value)})
            // writeFont8Black({page: page, font: font, x: 490, y: 453, text: numberWithCommasAndDecimal(A44Value)})
            // writeFont8Black({page: page, font: font, x: 490, y: 433, text: numberWithCommasAndDecimal(B44Value)})

            //commission 
            const commission = data.commision ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 422, text: numberWithCommasAndDecimal(commission)})

            //profit sharing
            const profitSharing = data.profitSharing ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 402, text: numberWithCommasAndDecimal(profitSharing)})

            //director's fee
            const directorFee = data.directorsFees ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 382, text: numberWithCommasAndDecimal(directorFee)})

            //taxable 13th month
            const taxableThirteenthMonth = data.isTaxableSalary ? data.nonTaxable13thMonth : 0;
            writeFont8Black({page: page, font: font, x: 490, y: 362, text: numberWithCommasAndDecimal(taxableThirteenthMonth)})

            //taxable hazard pay
            const taxableHazardPay = data.taxableHazardPay ?? 0
            writeFont8Black({page: page, font: font, x: 490, y: 343, text: numberWithCommasAndDecimal(taxableHazardPay)})

            //taxable overtime pay
            const taxableOvertimePay = data.isTaxableSalary ? data.otPay : 0;
            writeFont8Black({page: page, font: font, x: 490, y: 325, text: numberWithCommasAndDecimal(taxableOvertimePay)})

            //const taxable others
            const A51 = ""
            const B51 = ""
            const A51Value = data.taxableOtherA ?? 0;
            const B51Value = data.taxableOtherB ?? 0;
            writeFont8Black({page: page, font: font, x: 350, y: 295, text: A51})
            writeFont8Black({page: page, font: font, x: 350, y: 276, text: B51})
            writeFont8Black({page: page, font: font, x: 490, y: 295, text: numberWithCommasAndDecimal(A51Value)})
            writeFont8Black({page: page, font: font, x: 490, y: 276, text: numberWithCommasAndDecimal(B51Value)})

            //const taxable compensation income
            const taxableCompensationIncome = data.totalTaxableCompensation ?? 0;
            writeFont8Black({page: page, font: font, x: 490, y: 257, text: numberWithCommasAndDecimal(taxableCompensationIncome)})

            setShowRequestMessage(true);
            setIsSuccess(true);
    
            // Save the modified PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    
            // Trigger download
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `BIR_2316_${data.lastName}_${data.firstName}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
        
        setLoading(false);
    }, [dateFrom, dateTo]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/BIR2316/employee/${employeePersonalInformationId}/dateFrom/${dateFrom}/dateTo/${dateTo}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [modifyAndDownloadPDF, employeePersonalInformationId, dateFrom, dateTo]);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"BIR Form No. 2316"}</span>
                            </div>
                            <h3>Generate BIR Form No. 2316</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row items-center">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Employee</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Employee"
                                                value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowEmployeeForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                        {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                                    </div>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date From</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateFrom && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date To</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateTo} setDate={setDateTo}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateTo && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row" style={{justifyContent:"start"}}>
                                <button id="sssReportGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/masterlist";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    
    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}

export default BIR2316
